
import _BaseController from 'Controllers/Base/_BaseController';

import AjaxSubmit from 'FF/Models/Common/AjaxSubmit';

import 'bootstrap';
import OEmbed from 'FF/Vue/Common/Plugins/FFEmbed/OEmbed.vue';
import HtmlSourceCode from 'FF/Vue/Common/Plugins/FFEmbed/HtmlSourceCode.vue';

export default class extends _BaseController {

    ready() {
        super.ready();

        global.AjaxSubmit = new AjaxSubmit;
        
        global.FFEmbed.parse('body');
        global.FFEmbed.parseHtmlSourceCode('body');

        Vue.component('oembed', OEmbed);
        Vue.component('html-source-code', HtmlSourceCode);
    }

}
